module.exports = __webpack_public_path__ + "assets/img/db.413bc732.png";